export const nonEmptyWithNewLinesRegex = /^(?!\s*$).+/;

export const nonEmptyRegex = /^.*\S.*$/;

export const nonUndefinedOrNull = { test: (value: any) => value !== null && value !== undefined };
